/**
 * @file: orderTag.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { OrderTag } from '@euler/model';
import { serviceFactory } from '@euler/services/factory';
import { Observable } from 'rxjs';
import { AbstractSearchCriterionProvider } from '../AbstractSearchCriterionProvider';
import { SearchCriterionOption } from '../types';

export class OrderTagCriterion extends AbstractSearchCriterionProvider<'tag'> {
  static readonly shared = new OrderTagCriterion();

  private _orderTags: OrderTag[] | undefined;

  constructor() {
    super('tag');
  }

  getLabel(): string {
    return '服务类型';
  }

  internalGetDisplayText(value: OrderTag): string {
    // the value should be the name of the tag.
    return value.name;
  }

  internalGetOptions(): SearchCriterionOption<OrderTag>[] {
    throw new Error('Method not implemented.');
  }

  getOptions(): Observable<SearchCriterionOption<OrderTag>[]> {
    return new Observable(subscriber => {
      if (this._orderTags != null) {
        subscriber.next(this.makeOptions(this._orderTags));
      }
      // try to get the recent list of order tags.
      serviceFactory.inventoryService
        .getPredefinedOrderTags()
        .then(orderTags => {
          this._orderTags = orderTags;
          subscriber.next(this.makeOptions(orderTags));
          subscriber.complete();
        })
        .catch(err => {
          console.error(err);
          subscriber.next([]);
          subscriber.complete();
        });
    });
  }

  protected internalGetKey(value: OrderTag): string {
    return value.name;
  }

  private makeOptions(
    orderTags: OrderTag[],
  ): SearchCriterionOption<OrderTag>[] {
    return [{ value: undefined }, ...orderTags.map(value => ({ value }))];
  }
}
